import { isTauri } from '@/tauri/utils';
import { logger } from '@/utils/logger/logger';

const SIGN_IN_METHOD_KEY = 'heidi_sign_in_method';
const SCREEN_HINT_KEY = 'heidi_screen_hint';

export function setSignInMethod(method: string): void {
  if (isTauri() || typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(SIGN_IN_METHOD_KEY, method);
  } catch (error) {
    logger.warn('[Analytics] Failed to persist sign-in method', { error, method });
  }
}

export function setScreenHint(hint: string): void {
  if (isTauri() || typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(SCREEN_HINT_KEY, hint);
  } catch (error) {
    logger.warn('[Analytics] Failed to persist screen hint', { error, hint });
  }
}

export function getSignInTracking(): {
  method: string | null;
  screenHint: string | null;
} {
  if (isTauri() || typeof window === 'undefined') {
    return { method: null, screenHint: null };
  }
  return {
    method: sessionStorage.getItem(SIGN_IN_METHOD_KEY),
    screenHint: sessionStorage.getItem(SCREEN_HINT_KEY),
  };
}

export function clearSignInTracking(): void {
  if (isTauri() || typeof window === 'undefined') return;
  sessionStorage.removeItem(SIGN_IN_METHOD_KEY);
  sessionStorage.removeItem(SCREEN_HINT_KEY);
}
